import { ProjectLists } from './project-lists';
import { SidebarCollapsibleSection } from 'components/blocks/layout/sidebar-section';
import { IconName } from 'components/blocks/menu-icon/menu-icon';
import { useState } from 'react';
import { NewProjectModal } from './new-project-modal';
import { useQueryClient } from '@tanstack/react-query';
import { refetchProject } from '../helpers/query-utils';
import { useTranslation } from 'react-i18next';
// import { useChatStore } from 'state/store/chat/use-chat-store';

export const ProjectsSection = () => {
    const [isAddProjectModalOpen, setIsAddProjectModalOpen] = useState(false);
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    // const removeConversationFromSidebarById = useChatStore((state) => state.removeConversationFromSidebarById);

    return (
        <div className="mb-4">
            <SidebarCollapsibleSection
                title={t("PROJECTS_TITLE")}
                icon={'FolderDot' as IconName}
                onAddClick={() => setIsAddProjectModalOpen(true)}
            >
                <div className="flex flex-col">
                    <ProjectLists />
                </div>
            </SidebarCollapsibleSection>

            <NewProjectModal
                callback={() => {
                    refetchProject(queryClient, '');
                }}
                isOpen={isAddProjectModalOpen}
                onClose={() => setIsAddProjectModalOpen(false)}
            />
        </div>
    );
}